import styles from './GlobalFallback.module.scss';

/**
 * This is the global fallback component that is displayed when an error occurs for the main app.
 */
export const GlobalFallback: React.FC = () => (
    <div className={styles.root}>
        <h1>Oops! Something went wrong</h1>
        <p>We're sorry, but something unexpected happened.</p>
    </div>
);
